/** GA4 — mêmes règles de cache et de 401 que les autres sections. */

import type { Ga4Overview } from '@shared/types/ga4';
import type { TrafficStats } from '@shared/types/traffic';

import { fetchGa4Overview, fetchTrafficStats } from '../lib/api';
import { useSectionStats, type SectionStatsOptions } from './useSectionStats';

/** Sessions GA4 synchronisées, jour par jour (Résumé). */
export function useTrafficStats(options: SectionStatsOptions) {
  return useSectionStats<TrafficStats>('traffic-stats', fetchTrafficStats, options);
}

/** Page Analytics (GA4) : rapports lus en direct. */
export function useGa4Overview(options: SectionStatsOptions) {
  return useSectionStats<Ga4Overview>('ga4-overview', fetchGa4Overview, options);
}
